<template>
    <card-build-sub-menu
      :title="title"
      :menu="menu"
      height="180px"
      variant="#113fa9"
      :redirectToPath="redirectToPath"
    >
    </card-build-sub-menu>
  </template>
  <script>
    import CardBuildSubMenu from '@/components/build-card-menu/CardBuildSubMenu.vue'
    export default {
      components: {
        CardBuildSubMenu
      },
      data() {
        return {
          menu: [],
          title: 'CUMPLIMIENTO'
        }
      },
      computed: {
        armeTipo() {
          return this.$route.params.arme_tipo
        },
        armeId() {
          return this.$route.params.arme_id
        }
      },
      created() {
        this.buildMenu()
      },
      methods: {
        buildMenu() {
          const menu = JSON.parse(localStorage.getItem('menu'))
          this.menu = menu.flatMap(e1 =>
            e1.children.flatMap(e2 =>
              e2.children.flatMap(e3 =>
                e3.arme_tipo == this.armeTipo
                  ? e3.children.filter(
                      child => child.arme_padre_id == this.armeId
                    )
                  : []
              )
            )
          )
        },
        redirectToPath(path, arme_tipo, arme_id) {
          if (arme_tipo && arme_id) {
            const fullPath = `${path}/${arme_tipo}/${arme_id}`
            this.$router.push({ path: fullPath })
          } else {
            this.$router.push(path)
          }
        }
      }
    }
  </script>
  <style scoped>
    .menu-item-container {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      height: 100px;
      cursor: pointer;
      border-radius: 1rem;
      margin: 0.5rem;
      padding: 0.5rem;
      background-color: #f0f0f0;
    }
  </style>
  